module.exports = __webpack_public_path__ + "img/icon_5_25.46f64d0e.png";